import { useKeyPress, usePopoverContext } from '@lounge-fe/ui-kit'
import { useSearchParams } from '@/hooks/useSearchParams'
import { useSearchContext } from '@/features/navigation/components/Navigation/SearchProvider'
import { useEffect } from 'react'
import { useSearch } from '../useSearch'

export const useHeaderSearchState = () => {
  const { onClear: clearSearch } = useSearchContext()
  const { setIsSearchOpen, isSearchOpen } = useSearch()
  const { replace } = useSearchParams()
  const { isOpen: isPopoverOpen } = usePopoverContext()
  const isEscapePressed = useKeyPress('Escape')

  useEffect(() => {
    if (isEscapePressed && isPopoverOpen) {
      replace({ q: undefined })
      clearSearch()
      setIsSearchOpen(false)
    }
  }, [isEscapePressed, isPopoverOpen])

  useEffect(() => {
    if (isPopoverOpen && isSearchOpen !== isPopoverOpen) {
      replace({ q: undefined })
      clearSearch()
      setIsSearchOpen(isPopoverOpen)
    }
  }, [isSearchOpen, isPopoverOpen])
}
